import { memo, version } from "react";

import {
    ExperiencePerformanceTypes,
    payloadPublisher,
    TenantType
} from "@atlassian/ufo";
import { getAnalyticsWebClientPromise } from "@atlassian/wac-analytics-web-client-async";

export const InitUFO = memo(() => {
    getAnalyticsWebClientPromise().then((client) => {
        payloadPublisher.setup({
            featureFlagClient: { getValue: () => true },
            product: "marketing",
            gasv3: client.getInstance(),
            app: {
                version: { web: "1.0.0" },
                framework: { name: "react", version }
            },
            tenantType: TenantType.RealUser,
            resourceTimings: {
                mapResources: (url) => url,
                sanitiseEndpoints: (url) => url
            },
            performanceConfig: {
                histogram: {
                    [ExperiencePerformanceTypes.PageLoad]: {
                        initial: {
                            fmp: "1000_2000_3000_4000",
                            tti: "1000_2000_3000_4000"
                        },
                        transition: {
                            fmp: "1000_2000",
                            tti: "1000_2000"
                        }
                    },
                    [ExperiencePerformanceTypes.PageSegmentLoad]: {
                        initial: {
                            fmp: "1000_2000",
                            tti: "1000_2000"
                        },
                        transition: {
                            fmp: "1000_2000",
                            tti: "1000_2000"
                        }
                    },
                    [ExperiencePerformanceTypes.InlineResult]: {
                        result: "1000_2000",
                        response: "1000_2000"
                    },
                    [ExperiencePerformanceTypes.Custom]: {
                        duration: "1000_2000"
                    }
                }
            }
        });
    });

    return null;
});
